import { useState } from 'react'
import { styled } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded'
import Toggle from '../../../view/components/editors/toggle/Toggle'
import { intl } from '../../../i18n'
import { colorPalette } from '../../../view/style/colorPalette'
import { Color, FontWeight } from '../../../styles/commonStyles'
import { Text } from '../../../view/components/typography'
import flagxsTenantIcon from '../../../assets/flagxs_tenant_icon.png'
import projectSelectedIcon from '../../../assets/project_selected_icon.png'
import flagxsLogo from '../../../assets/flagxs_logo_horizontal_color.svg'

// 本物のSideMenu（view/containers/SideMenu）はプロジェクト切替・機能マスタ由来の
// 動的メニューを持つが、デモではそれらのAPI/state自体が存在せず、画面遷移も
// SideMenu経由では行わない方針のため、テナントアイコン（ロゴ）と「プロジェクトを
// 選択」ボタン（押下しても何も起きない）のみの静的表示とする。
// 開閉トグルは見た目として必要なため、本物同様のToggleボタンで幅を切り替える
// （状態はstate.sideMenu.openに依存しないローカルstateで持つ）。折りたたみ時は
// テナントアイコンのみのMinimizedMenu相当の見た目にする。
export const DEMO_SIDE_MENU_WIDTH = 240
const DEMO_SIDE_MENU_MINIMIZED_WIDTH = 40

const RootContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  flexShrink: 0,
  height: '100%',
})

const Container = styled('nav')<{ open: boolean }>(({ open }) => ({
  width: `${open ? DEMO_SIDE_MENU_WIDTH : DEMO_SIDE_MENU_MINIMIZED_WIDTH}px`,
  height: '100%',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  background: colorPalette.monotone[0],
  borderRight: `1px solid ${colorPalette.monotone[2]}`,
  overflow: 'hidden',
  transition: 'width 0.2s',
}))

const ToggleWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  zIndex: 1000,
})

const TenantBar = styled('div')({
  height: '56px',
  width: '100%',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: colorPalette.skyBlue[7],
})

const Logo = styled('img')({
  height: '18px',
})

const MinimizedLogo = styled('img')({
  height: '24px',
  width: '24px',
  borderRadius: '4px',
})

const ProjectRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 0',
})

const ProjectButton = styled(Button)({
  margin: '0 5px',
  height: 'fit-content',
  '&:hover': { background: 'transparent' },
})

export const DemoSideMenu = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <RootContainer>
      <Container open={isOpen}>
        <TenantBar>
          {isOpen ? (
            <Logo src={flagxsLogo} alt="FLAGXS" />
          ) : (
            <MinimizedLogo src={flagxsTenantIcon} alt="FLAGXS" />
          )}
        </TenantBar>
        {isOpen && (
          <ProjectRow>
            <ProjectButton disableRipple={true}>
              <Avatar
                variant="rounded"
                src={projectSelectedIcon}
                sx={{
                  margin: '0 8px 0 16px',
                  height: '24px',
                  width: '24px',
                }}
              />
              <Text
                variant="s"
                color={colorPalette.monotone[5]}
                style={{ fontWeight: FontWeight.BOLD }}
              >
                {intl.formatMessage({ id: 'menu.project.unselected' })}
              </Text>
              <NavigateNextRoundedIcon
                sx={{ color: Color.MONOTONE, height: '15px', width: '15px' }}
              />
            </ProjectButton>
          </ProjectRow>
        )}
      </Container>
      <ToggleWrapper
        style={{
          left: isOpen ? DEMO_SIDE_MENU_WIDTH : DEMO_SIDE_MENU_MINIMIZED_WIDTH,
        }}
      >
        <Toggle
          isOpen={isOpen}
          attach="left"
          toggle={e => {
            e.preventDefault()
            e.stopPropagation()
            setIsOpen(prev => !prev)
          }}
        />
      </ToggleWrapper>
    </RootContainer>
  )
}
